import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import HeaderInternationalProxy from '../proxies/HeaderInternationalProxy'

class HeaderInternationalService extends ServiceBase {
  getCountries(params) {
    return this.getData(() => HeaderInternationalProxy.getCountries(params))
  }

  getSearchHistory(params) {
    return this.getData(() => HeaderInternationalProxy.getSearchHistory(params))
  }

  postSearchHistory(params) {
    return this.getData(() =>
      HeaderInternationalProxy.postSearchHistory(params),
    )
  }

  deleteSearchHistory(params) {
    return this.getData(() =>
      HeaderInternationalProxy.deleteSearchHistory(params),
    )
  }

  getCompany(params) {
    return this.getData(() => HeaderInternationalProxy.getCompany(params))
  }
}

export default new HeaderInternationalService()
